import './style.scss';

export default function Loading() {
  return (
    <div className="loading">
      <div className="loading__container">
        <div className="loading__circle loading__circle1" />
        <div className="loading__circle loading__circle2" />
        <div className="loading__circle loading__circle3" />
        <div className="loading__circle loading__circle4" />
      </div>
    </div>
  );
}
